import { apiAction } from '../../shared/store/apiAction';

import * as api from './api';
import {
  fetchFilingGroupsTypes,
  fetchFilingGroupsByFilingTypeTypes,
  fetchAllJurisdictionsTypes,
  SELECT_FILING_GROUP_ID,
  SELECT_JURISDICTION_ID_FOR_FILING_GROUP,
  updateFilingGroupTypes,
  createFilingGroupTypes,
} from './types';

export const fetchFilingGroups = apiAction({
  types: fetchFilingGroupsTypes,
  apiAction: ({ taxYear, period }) => api.fetchFilingGroups({ taxYear, period }),
});

export const fetchFilingGroupsByFilingType = apiAction({
  types: fetchFilingGroupsByFilingTypeTypes,
  apiAction: ({ taxYear, period, filingTypeId, businessEntityId }) =>
    api.fetchFilingGroupsByFilingType({ taxYear, period, filingTypeId, businessEntityId }),
});

export const fetchAllJurisdictions = apiAction({
  types: fetchAllJurisdictionsTypes,
  apiAction: api.fetchAllJurisdictions,
});

export const selectFilingGroupId = filingGroupId => ({
  type: SELECT_FILING_GROUP_ID,
  payload: filingGroupId,
});

export const selectJurisdictionIdForFilingGroup = jurisdictionId => ({
  type: SELECT_JURISDICTION_ID_FOR_FILING_GROUP,
  payload: jurisdictionId,
});

export const updateFilingGroup = apiAction(
  {
    types: updateFilingGroupTypes,
    apiAction: api.updateFilingGroup,
  },
  { successNotificationMessage: () => 'State filing group has been successfully updated' },
);

export const createFilingGroup = apiAction(
  {
    types: createFilingGroupTypes,
    apiAction: api.createFilingGroup,
  },
  { successNotificationMessage: () => 'State filing group has been successfully created' },
);
